/** Shared TanStack Query keys for Partner Dashboard schema definitions and mappings. */
export const schemaDefinitionKeys = {
  all: ['schemaDefinitions'] as const,
  list: () => [...schemaDefinitionKeys.all, 'list'] as const,
  detail: (schemaDefinitionId: string) =>
    [...schemaDefinitionKeys.all, 'detail', schemaDefinitionId] as const,
} as const;

export const schemaMappingKeys = {
  all: ['schemaMappings'] as const,
} as const;
